import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IECheck } from 'src/app/core/interfaces/payments/IECheck';
import { PaymentsService } from 'src/app/core/services/payments.service';

import { NavController, ModalController, Platform } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';
import { PaymentsDataService } from 'src/app/core/services/data/payments.data.service';
import { FileService } from 'src/app/core/services/file.service';
import { ICreditCard } from 'src/app/core/interfaces/payments/ICreditCard';
import { ICustomerInvoice } from 'src/app/core/interfaces/payments/ICustomerInvoice';
import { DeviceService } from 'src/app/core/services/device.service';
import { PaymentSuccessModalComponent } from '../payment-success-modal/payment-success-modal.component';

declare let window: any;

@Component({
  selector: 'app-payment-modal',
  templateUrl: './payment-modal.component.html',
  styleUrls: ['./payment-modal.component.scss'],
  standalone: false
})
export class PaymentModalComponent implements OnInit, OnDestroy {
  public paymentMethod: string;
  public paymentMethodInfo: FormGroup;
  public amountDue: number;
  public description = 'Temp';
  // public invoiceId: string;
  // public orderId: string;
  // public taxReturnId: string;
  public paymentSuccessful: boolean;

  @Input() customerInvoice: ICustomerInvoice;

  public sub: any;

  private storageLocation: any;

  constructor(
    private formBuilder: FormBuilder,
    private paymentsService: PaymentsService,
    private navController: NavController,
    private route: ActivatedRoute,
    private fileService: FileService,
    private paymentsDataService: PaymentsDataService,
    private modalController: ModalController,
    private platform: Platform,
    private deviceService: DeviceService
  ) {
    this.paymentMethodInfo = this.formBuilder.group({
      paymentMethod: this.formBuilder.control('', [Validators.required])
    });

    this.platform.ready().then(() => {
      if (this.deviceService.isAndroid()) {
        // For Android, we use SAF MediaStore plugin (customautosys) directly
        // storageLocation is not needed for Android downloads
        this.storageLocation = null;
      } else if (this.deviceService.isIOS()) {
        // Use Documents directory - Downloads folder will be created by file service
        this.storageLocation = window.cordova.file.documentsDirectory;
      } else {
        // Desktop/Web - no storage location needed
        this.storageLocation = null;
      }
    });
  }

  public ngOnInit(): void {}

  public getCustomerInvoice() {
    this.paymentsService
      .getCustomerInvoiceDocument(
        this.customerInvoice.orderId,
        this.customerInvoice.invoiceId,
        false
      )
      .subscribe((res) => {
        const document = res.data;
        this.fileService.manageViewFile(
          document[0].documentBase64,
          document[0].fileName + '.pdf'
        );
      });
  }

  public completeCreditCardPayment(payment: ICreditCard): void {
    this.paymentsService
      .addCreditCardPayment(
        payment,
        this.customerInvoice.taxReturnId,
        this.customerInvoice.orderId,
        false
      )
      .subscribe((paymentReceipt) => {
        this.paymentsDataService.setOrderId(this.customerInvoice.orderId);
        this.paymentsDataService.setPaymentId(paymentReceipt.paymentId);
        this.paymentsDataService.setPaymentMethod('CreditCard');
      });
    this.modalController.dismiss();
    this.displayPaymentSuccessModal();
  }

  public completeECheckPayment(payment: IECheck): void {
    this.paymentsService
      .addECheckPayment(
        payment,
        this.customerInvoice.taxReturnId,
        this.customerInvoice.orderId,
        false
      )
      .subscribe((paymentReceipt) => {
        this.paymentsDataService.setOrderId(this.customerInvoice.orderId);
        this.paymentsDataService.setPaymentId(paymentReceipt.paymentId);
        this.paymentsDataService.setPaymentMethod('ECheck');
      });
    this.modalController.dismiss();
    this.displayPaymentSuccessModal();
  }

  public setCreditCard(): void {
    this.paymentMethod = 'CreditCard';
  }

  public setECheck(): void {
    this.paymentMethod = 'ECheck';
  }

  public displayPaymentSuccessModal(): void {
    this.modalController
      .create({
        component: PaymentSuccessModalComponent,
        componentProps: {}
        //cssClass: 'twoActionModal'
      })
      .then((modal) => {
        modal.present();
        modal.onDidDismiss().then((response) => {});
      });
  }

  public backToPaymentPortal(): void {
    this.modalController.dismiss();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
